// src/IT/components/ActivityTable.jsx
import React from "react";

export default function ActivityTable({ events }) {
  const rows = events || [];
  return (
    <div className="it-card">
      <div className="it-card-title">Activity</div>

      <table className="it-table">
        <thead>
          <tr>
            <th>Time</th>
            <th>Event</th>
            <th>By</th>
            <th>Message</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((e) => (
            <tr key={e.id}>
              <td>{new Date(e.created_at).toLocaleString()}</td>
              <td>{e.event_type}</td>
              <td>{e.actor_email || "-"}</td>
              <td style={{ whiteSpace: "pre-wrap" }}>{e.message || "-"}</td>
            </tr>
          ))}
          {!rows.length && (
            <tr>
              <td colSpan="4" className="it-muted">No activity yet.</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
